import { ProviderClaimsActivityRecord } from "./models/providerClaimsActivityRecord";
import AccuracyEvidenceRow from "./AccuracyEvidenceRow";
import { JSX } from "react";

interface AccuracyEvidenceProviderClaimsActivityTabProps {
    src: ProviderClaimsActivityRecord;
    expanding: boolean;
}

export default function AccuracyEvidenceProviderClaimsActivityTab(evidence: AccuracyEvidenceProviderClaimsActivityTabProps): JSX.Element{
    return(
        evidence.src ? 
            <>
                <div className="card">
                    <ul className="list-group list-group-flush">
                        <li className="list-group-item bordered evidence-header">
                            <div className="col-4">
                                <b>Value</b>
                            </div>
                            <div className="col-4">
                                <b>Value (Status)</b>
                            </div>
                            <div className="col-4">
                                <b>Verification Reference</b>
                            </div>
                        </li>
                        <>
                            <li className="list-group-item bordered" data-toggle="collapse" data-target="#practitioner">
                                <div className="col-12">
                                    <span className="expandable">Practitioner</span>
                                </div>
                            </li>
                            <div className="collapse" id="practitioner">
                                <li className="list-group-item bordered" data-toggle="collapse" data-target="#pca">
                                    <div className="col-12 evidence-depth-2">
                                        <span className="expandable">{evidence.src.Name}</span>
                                    </div>
                                </li>
                                <div className="collapse" id="pca">
                                    <AccuracyEvidenceRow keyName="npi" value="National Provider Identification Number" status={evidence.src.NPI} reference={`Provider Claims Activity ${evidence.src.ActivationDate}`} rowDepth="3"/>
                                    <AccuracyEvidenceRow keyName="name" value="Name" status={evidence.src.Name} reference={evidence.src.NppesCreatedDate && `NPPES ${evidence.src.NppesCreatedDate}`} rowDepth="3"/>
                                    <div key="claims-volume">
                                        <li className="list-group-item bordered" data-toggle="collapse" data-target="#claimsVolumes">
                                            <div className={`col-4 evidence-depth-3`}>
                                                <span className="expandable">Claims Volume</span>
                                            </div>
                                        </li>
                                        <div className="collapse" id="claimsVolumes">
                                            <AccuracyEvidenceRow keyName="commercialVolume" value="Commercial" status={evidence.src.CommercialClaimsLabel} reference={`Provider Claims Activity ${evidence.src.ActivationDate}`} rowDepth="4"/>
                                            <AccuracyEvidenceRow keyName="medicaidVolume" value="Medicaid" status={evidence.src.MedicaidClaimsLabel} reference={`Provider Claims Activity ${evidence.src.ActivationDate}`} rowDepth="4"/>
                                            <AccuracyEvidenceRow keyName="medicareVolume" value="Medicare" status={evidence.src.MedicareClaimsLabel} reference={`Provider Claims Activity ${evidence.src.ActivationDate}`} rowDepth="4"/>
                                            <AccuracyEvidenceRow keyName="totalVolume" value="Total" status={evidence.src.TotalClaimsLabel} reference={`Provider Claims Activity ${evidence.src.ActivationDate}`} rowDepth="4"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    </ul>
                </div>
            </>
            : !evidence.expanding
                ? <p>No corroborating data found for this provider</p>
                : <p></p>
    );
}